import {BrowserRouter, Route, Routes, } from "react-router-dom";

import IndexPage from './components/IndexPage';
//import JoinRoom from './components/JoinRoom'
import Room from './components/Rooms';

function App() {
  

  return (
    <div className="App">
      <BrowserRouter>
      <div> Welcome to AVSecure.VIP... all the security, all the live video conferencing, all of the time.</div>
      <br/>
      <br/>
        <Routes>
          <Route path="/" element={<IndexPage />}></Route>
          <Route path="/room/:roomID" element={<Room/>}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  )
} 

export default App
